import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PasswordRuleRow } from './PasswordRuleRow';

const keyPrefix = 'components.form-outputs.PasswordMatchNotice';

type Props = {
  confirmation: string;
  password: string;
};

/**
 * Dice si la confirmación coincide con la contraseña nueva, mientras se
 * escribe. Sin esto, el vendedor solo se entera al enviar, y en un teclado de
 * celular una diferencia de un carácter en un campo oculto es difícil de ver.
 *
 * Con la confirmación vacía no se muestra nada: al abrir la pantalla los dos
 * campos están vacíos y serían «iguales», que es una coincidencia que no
 * significa nada y solo ensucia.
 */
export const PasswordMatchNotice: FC<Props> = ({
  confirmation,
  password,
}): JSX.Element | null => {
  const { t } = useTranslation('translation', { keyPrefix });

  if (!confirmation) return null;

  const matches = confirmation === password;

  return (
    <PasswordRuleRow component='div' state={matches ? 'met' : 'failed'}>
      {matches ? t('match') : t('mismatch')}
    </PasswordRuleRow>
  );
};
